import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchApi } from "Config/fetchApi";
import { handleError } from "Helper";

// Initial state
const initialState = {
  streamingBackgroundGetImageStreaming: {
    datastreamingBackgroundGetImageStreaming: [],
    isLoadingstreamingBackgroundGetImageStreaming: false,
    errorstreamingBackgroundGetImageStreaming: null,
  },
};

// Thunk action for fetching jurisdiction list
export const getstreamingBackgroundGetImageStreaming = createAsyncThunk(
  "jurisdiction/getstreamingBackgroundGetImageStreaming",
  async (
    { page = 0, size = 99, uuid_person_fr = "" } = {},
    { rejectWithValue }
  ) => {
    try {
      const api = fetchApi(); // Menggunakan fetchApi
      const url = `/streaming-background/get-image-streaming/${uuid_person_fr}?uuid=${uuid_person_fr}`;
      const result = await api.get(url);
      return result?.data;
    } catch (error) {
      console.error(error);
      handleError(error);
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Slice definition
const streamingBackgroundGetImageStreamingSlice = createSlice({
  name: "streamingBackgroundGetImageStreaming",
  initialState,
  reducers: {
    setstreamingBackgroundGetImageStreaming: (state, action) => {
      state.streamingBackgroundGetImageStreaming.datastreamingBackgroundGetImageStreaming =
        action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getstreamingBackgroundGetImageStreaming.pending, (state) => {
        state.streamingBackgroundGetImageStreaming.isLoadingstreamingBackgroundGetImageStreaming = true;
        state.streamingBackgroundGetImageStreaming.errorstreamingBackgroundGetImageStreaming =
          null;
      })
      .addCase(
        getstreamingBackgroundGetImageStreaming.fulfilled,
        (state, action) => {
          state.streamingBackgroundGetImageStreaming.isLoadingstreamingBackgroundGetImageStreaming = false;
          state.streamingBackgroundGetImageStreaming.datastreamingBackgroundGetImageStreaming =
            action.payload || [];
          state.streamingBackgroundGetImageStreaming.errorstreamingBackgroundGetImageStreaming =
            null;
        }
      )
      .addCase(
        getstreamingBackgroundGetImageStreaming.rejected,
        (state, action) => {
          state.streamingBackgroundGetImageStreaming.isLoadingstreamingBackgroundGetImageStreaming = false;
          state.streamingBackgroundGetImageStreaming.errorstreamingBackgroundGetImageStreaming =
            action.payload;
        }
      );
  },
});

// Export reducer dan action
export const { setstreamingBackgroundGetImageStreaming } =
  streamingBackgroundGetImageStreamingSlice.actions;
export default streamingBackgroundGetImageStreamingSlice.reducer;
